'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.video = twentyninetimes.video || function () {

	function init() {
		var blockVideos = document.querySelectorAll('.wp-block-video');
		if ( blockVideos ) {
			videoFunction(blockVideos);
		}
	}

	function videoFunction(blockVideos) {
	    blockVideos.forEach(blockVideo => {
	        var video = blockVideo.querySelector('video');

	        blockVideo.classList.add('frontend');

	        if ( video.hasAttribute('autoplay') ) return;
	        // if ( video.hasAttribute('controls') )
	        //     video.removeAttribute('controls');

	        blockVideo.classList.add('has-play-btn');

	        var buttonEl = document.createElement("button");
	        buttonEl.setAttribute('class', 'wp-block-video__play-btn');
	        buttonEl.setAttribute('type', 'button');
	        buttonEl.innerHTML = 'Se video';

	        blockVideo.appendChild(buttonEl);

	        buttonEl.addEventListener("click", function(e) {
	            e.stopPropagation();

	            if (video.paused == true) {
	              // Play the video
	              video.play();

	              blockVideo.classList.add('has-play-btn--hidden');
	            } else {
	              // Pause the video
	              video.pause();

	              buttonEl.innerHTML = 'Fortsæt video';
	              blockVideo.classList.remove('has-play-btn--hidden');
	            }
	        });
	    });
	}

	return {
		init : init
	};

}();